import React from "react";
import styles from "./LandingPage.module.css";
import { Link } from "react-router-dom";
import CTASection from "../../CTASection/CTASection";
import PackageCard from "./PackageCard";

import heroImage from "./hero.webp";
import couple from "./couple image1.webp";
import family from './family image.webp';

export default function LandingPage() {
  return (
    <main className={styles.container}>

    <section
  className={styles.hero}
  style={{
    backgroundImage: `url(${heroImage})`,
  }}
>
        <div className={styles.heroOverlay}>
          <h1>Experience the Magic of Meghalaya: Best-Selling Tour Packages 2026</h1>
          <p>
Discover the hidden gems of Meghalaya with Atlas Travel House. Whether you're seeking a serene romantic escape or a thrill-filled family vacation, our handcrafted tour packages are designed to give you a deep dive into the misty hills and vibrant Khasi culture. With 24/7 local support and handpicked stays, we turn your travel dreams into reality. Plan your perfect journey with Atlas Travel House today!</p>
        </div>
      </section>
  


<section className={styles.cards}>

  <PackageCard
    image={couple}
    title="Meghalaya Couple & Honeymoon Special"
    highlights={[
      "<b>Shillong:</b> Romantic café experiences & serene lake walks in Shillong",
      "<b>Cherrapunji:</b> Majestic waterfalls & misty valleys in Cherrapunjee",
      "<b>Dawki:</b> Crystal-clear river boating at Dawki",
      "<b>Mawlynnong:</b> Living Root Bridge & nature walks at Mawlynnong",
      "<b>Stays:</b> Handpicked comfortable stays (3 Star)",
    ]}
    destinations="Shillong – Cherrapunjee – Dawki – Mawlynnong"
    duration="5 Nights / 6 Days"
    price="₹35,000 / person (on twin sharing)"
    detailsLink="/meghalayatourpackage/couple"
  />

  <PackageCard
    image={family}
    title="Meghalaya Family Holiday Package"
    highlights={[
      "<b>Shillong:</b> Full city tour & local market experience in Shillong",
      "<b>Cherrapunji:</b> Grand waterfalls & easy scenic sightseeing in Cherrapunjee",
      "<b>Dawki:</b> Safe & enjoyable river boating at Dawki",
      "Family-friendly hotels (3 Star) & comfortable travel",
      "Relaxed itinerary suitable for all age groups",
    ]}
    destinations="Shillong – Cherrapunjee – Dawki – Mawlynnong"
    duration="5 Nights / 6 Days"
    price="₹25,000 / person (on twin sharing)"
    detailsLink="/meghalayatourpackage/family"
  />

</section>

     <CTASection
  heading="Plan Your Dream Northeast Adventure Today!"
  description="Don't let difficult terrain or permit hassles stop you. Let Atlas Travel House craft your perfect Seven Sisters itinerary with expert drivers, handpicked homestays, and seamless planning."
  buttonText="Get Your Custom Northeast Plan"
  buttonLink="tel:+919876543210" 
/>

<section className={styles.disclaimer}>
  <div className={styles.marquee}>
    <p>
      *All package prices are indicative and subject to change based on travel dates,
      availability, and customizations. Final pricing may vary depending on hotel
      selection, inclusions, and seasonal demand. Please contact Atlas Travel House
      for a personalized quote.
    </p>
  </div>
</section>




    </main>
  );
}